module.exports = __webpack_public_path__ + "img/excel.9bc6430e.svg";